<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <msi-content-modal #modal [modalRef]="$any(modalRef)" [items]="matchedLocations">
    <msi-content-modal-title>
      <span class="msi-content-modal-title">{{ t('Item.modal.selectAddress.header') }}</span>
    </msi-content-modal-title>
    <div class="msi-content-modal-item">
      <div class="select-geocode-row">
        <div>
          <label class="msi-label">{{ t('label.distance') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.distance | number:'1.0-2' }} {{ 'Units.meter' | transloco }} / {{ matchedLocations[modal.index()].matchLocation.distance ?? 0 * 3.28084 | number:'1.0-3' }} {{ 'Units.foot' | transloco }}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.matchStrength') }}</label>
          {{ matchedLocations[modal.index()].score }}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.locationType') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.locationMark | emptyText: t('Item.text.noInformation')}}
        </div>
      </div>
      @if (matchedLocations[modal.index()].matchLocation.commonplace) {
        <div class="select-geocode-row">
          <label class="msi-label">{{ t('label.locationName') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.commonplace | emptyText: t('Item.text.noInformation') }}
        </div>
      }
      <div class="select-geocode-row">
        <div>
          <label class="msi-label">{{ t('label.address') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.houseAddress | emptyText: t('Item.text.noInformation') }}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.intersection') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.intersection | emptyText: t('Item.text.noInformation') }}
        </div>
      </div>
      <div class="select-geocode-row">
        <div>
          <label class="msi-label">{{ t('label.city') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.city | emptyText: t('Item.text.noInformation') }}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.state') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.state | emptyText: t('Item.text.noInformation') }}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.zipCode') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.zipCode | emptyText: t('Item.text.noInformation') }}
        </div>
      </div>
      <div class="select-geocode-row">
        <div>
          <label class="msi-label">{{ t('label.longitude') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.x | number:'1.0-6' }}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.latitude') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.y | number:'1.0-6'}}
        </div>
        <div class="select-geocode-item-margin">
          <label class="msi-label">{{ t('label.geocoder') }}</label>
          {{ matchedLocations[modal.index()].sourceGeocoder | emptyText: t('Item.text.noInformation') }}
        </div>
      </div>
      @if (matchedLocations[modal.index()].matchLocation.description) {
        <div class="select-geocode-row">
          <label class="msi-label">{{ t('label.description') }}</label>
          {{ matchedLocations[modal.index()].matchLocation.description | emptyText: t('Item.text.noInformation') }}
        </div>
      }
      <div class="form-row-bottom">
        <div>
          <button type="button" pButton (click)="modalRef.close(modal.index())"><msi-icon name="ic_add" />{{ t('Item.modal.selectAddress.confirmButton') }}</button>
        </div>
        <div>
          <button type="button" pButton (click)="modalRef.close(-1)"><msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.close' | transloco }}</button>
        </div>
      </div>
    </div>
  </msi-content-modal>
</ng-container>
